import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import app from '../../main'
import Crud from '../crud'
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  folio: payload.folio
})
var crud = new Crud('Quotations', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  quotations: [],
  quotation: [],
  customers: [],
  contacts: [],
  products: [],
  details: [],
  currencies: [],
  loader: false,
  isAuthorizeQuotationModalVisible: false,
  isModalContactsVisible: false
}

const mutations = {
  ...crud.mutations,
  SET_CUSTOMERS_CATALOG (state, payload) {
    state.customers = payload.data
  },
  SET_CONTACTS_CATALOG (state, payload) {
    state.contacts = payload
  },
  SET_CURRENCIES_CATALOG (state, payload) {
    state.currencies = payload.data
  },
  SET_PRODUCTS_CATALOG (state, payload) {
    state.products = payload
  },
  SET_PRODUCT_DETAIL (state, payload) {
    state.details = payload
  },
  SET_QUOTATION_FORM (state, payload) {
    state.quotation = payload
  },
  ADD_QUOTATION_FORM (state, payload) {
    state.quotations.unshift = payload
  },
  SET_BRANCHES_CATALOG (state, payload) {
    state.branches = payload.data
  },
  SET_DETAILS_IMPORT (state, payload) {
    state.details.push(...payload)
  },
  SET_LOADER_VISIBLE (state, payload) {
    state.loader = payload
  },
  ADD_PRODUCT_DETAIL (state, payload) {
    const idx = state.details.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.details, idx, payload)
    } else {
      state.details.unshift(payload)
    }
  },
  DELETE_PRODUCT_DETAIL (state, payload) {
    const idx = state.details.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.details, idx)
    }
  },
  SET_AUTHORIZE_QUOTATION_MODAL (state, payload) {
    state.isAuthorizeQuotationModalVisible = payload
  },
  SET_MODAL_CONTACTS_VISIBLE (state, payload) {
    state.isModalContactsVisible = payload
  }
}

const actions = {
  ...crud.actions,
  async loadCustomerCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`customers`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CUSTOMERS_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadProductsCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`products/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PRODUCTS_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadContactsCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`customer/${payload}/contacts`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CONTACTS_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadRequisitionersCatalog ({ dispatch }, payload) {
    dispatch('Requisitioners/loadRecords', payload, { root: true })
  },
  async loadBranchesCatalog ({ dispatch }, payload) {
    dispatch('Branches/loadRecords', payload, { root: true })
  },
  async loadCurrenciesCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`currencies`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CURRENCIES_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async saveQuotition ({ commit }, payload) {
    let formData = new FormData()
    payload.form.files.forEach(file => {
      formData.append('files[]', file)
    })
    if (!payload.form.branchIds) {
      delete (payload.form.branchIds)
    }
    formData.append('form', JSON.stringify({
      ...payload.form,
      customer_id: payload.form.customer.id,
      customer_name: payload.form.customer.name,
      contact_id: payload.form.contact ? payload.form.contact.id : null,
      contact_name: payload.form.contact ? payload.form.contact.name : null
    }))

    app.$Progress.start()
    commit('SET_LOADER_VISIBLE', true)
    try {
      const response = await axios.post(`quotations`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADER_VISIBLE', false)
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADER_VISIBLE', false)
        commit('SET_CONTACTS_CATALOG', response.data)
      }
    } catch (e) {
      commit('SET_LOADER_VISIBLE', false)
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADER_VISIBLE', false)
      app.$Progress.finish()
      app.$router.push({ name: 'quotations' })
    }
  },
  async updateQuotition ({ commit }, payload) {
    let formData = new FormData()
    payload.form.files.forEach(file => {
      if (file.type) {
        formData.append('files[]', file)
      }
    })
    if (!payload.form.branchIds) {
      delete (payload.form.branchIds)
    }
    formData.append('form', JSON.stringify({
      ...payload.form,
      customer_id: payload.form.customer.id,
      customer_name: payload.form.customer.name,
      contact_id: payload.form.contact ? payload.form.contact.id : null,
      contact_name: payload.form.contact ? payload.form.contact.name : null
    }))

    app.$Progress.start()
    commit('SET_LOADER_VISIBLE', true)
    try {
      const response = await axios.post(`quotations/${payload.form.id}`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADER_VISIBLE', false)
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADER_VISIBLE', false)
        commit('SET_CONTACTS_CATALOG', response.data)
      }
    } catch (e) {
      commit('SET_LOADER_VISIBLE', false)
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADER_VISIBLE', false)
      app.$Progress.finish()
      app.$router.push({ name: 'quotations' })
    }
  },
  async loadQuotation ({ commit }, id) {
    app.$Progress.start()
    try {
      const response = await axios.get(`quotations/${id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotation', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTATION_FORM', response.data.data)
        commit('SET_PRODUCT_DETAIL', response.data.data.details)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deletedFile ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`/quotations/${payload.id}/delete-file`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotation', text: checkErrors.message }, { root: true })
      } else {
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReportQuotation ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/quotations/export-quotation/${payload}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printPDFReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/quotations/download-pdf`, state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printDownloadPDF ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/quotations/${payload.id}/pdf/${payload.fileName}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async cloneReportQuotation ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADER_VISIBLE', true)
    try {
      const response = await axios.post(`quotations/${payload}/replicate`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADER_VISIBLE', false)
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotation', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADER_VISIBLE', false)
        commit('ADD_RECORD', response.data)
      }
    } catch (e) {
      commit('SET_LOADER_VISIBLE', false)
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADER_VISIBLE', false)
      app.$Progress.finish()
      app.$router.push({ name: 'quotations' })
    }
  },
  async makeRecordsFromExcel ({ commit }, payload) {
    let formData = new FormData()
    formData.append('file', payload.file[0])

    app.$Progress.start()
    commit('SET_LOADER_VISIBLE', true)
    try {
      const response = await axios.post(`quotations/details/file`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_LOADER_VISIBLE', false)
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADER_VISIBLE', false)
        commit('SET_DETAILS_IMPORT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_LOADER_VISIBLE', false)
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  openFile ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${payload}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async downloadTemplate ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${Vue.axios.defaults.baseURL}/quotations/template-details`)
    } catch (error) {
      app.$Progress.fail()
    } finally {
      app.$Progress.finish()
    }
  },
  setProductDetails ({ commit }, payload) {
    commit('SET_PRODUCT_DETAIL', payload)
  },
  setLoaderVisible ({ commit }, payload) {
    commit('SET_LOADER_VISIBLE', payload)
  },
  setModalRequisitionersVisible ({ commit }, payload) {
    commit('Requisitioners/SET_MODAL_VISIBLE', payload, { root: true })
  },
  setModalBranchesVisible ({ commit }, payload) {
    commit('Branches/SET_MODAL_VISIBLE', payload, { root: true })
  },
  setModalContactsVisible ({ commit }, payload) {
    commit('SET_MODAL_CONTACTS_VISIBLE', payload)
  },
  addProductDetails ({ commit }, payload) {
    commit('ADD_PRODUCT_DETAIL', payload)
  },
  deleteProducDetail ({ commit }, payload) {
    commit('DELETE_PRODUCT_DETAIL', payload)
  },
  setAuthorizeQuotationModalVisible ({ commit }, payload) {
    commit('SET_AUTHORIZE_QUOTATION_MODAL', payload)
  },
  async addContact ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post(`contacts`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_CONTACTS_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.contact', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  quotations: state => state.quotations,
  quotation: state => state.quotation,
  customers: state => state.customers,
  contacts: state => state.contacts,
  products: state => state.products,
  details: state => state.details,
  currencies: state => state.currencies,
  loader: state => state.loader,
  requisitioners: (state, getters, rootState, rootGetters) => rootGetters['Requisitioners/requisitioners'],
  branches: (state, getters, rootState, rootGetters) => rootGetters['Branches/branches'],
  isAuthorizeQuotationModalVisible: state => state.isAuthorizeQuotationModalVisible,
  isModalContactsVisible: state => state.isModalContactsVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
